import { PlanType } from '@showbie-socrative/socrative-utils';
import { QueryClient, useQuery } from '@tanstack/react-query';

import { QUIZ_LIMIT_QUERY_KEY } from '~teacher/hook/useQuizLimit/queryKeys';
import { proCheck } from '~teacher/util/proCheck';

import { getQuizLimit } from '../../../api/quiz';

export const defaultOptions = (userPlan: PlanType) => ({
  queryKey: QUIZ_LIMIT_QUERY_KEY,
  queryFn: () => getQuizLimit(userPlan),
});

export function useQuizLimit() {
  const userPlan = proCheck.userPlan();
  return useQuery(defaultOptions(userPlan));
}

export function queryQuizLimit(queryClient: QueryClient) {
  const userPlan = proCheck.userPlan();
  return queryClient.fetchQuery(defaultOptions(userPlan));
}
